import CommentsType from '../types/comments';
import baseApi from './base';
import {
  CommentsTag,
  FrameCommentsTag,
  ReviewerCommentsTag,
  ReviewerElearningCommentsTag,
} from './tags';

interface UpdateComment {
  id?: string;
  comment?: string;
  status?: number;
  lcmsReferenceIds?: any;
  isDeleted?: boolean | null;
  createdAt?: Date;
  modifiedAt?: Date;
}

interface SubmitData {
  id: string;
  content: UpdateComment;
}

interface CreateComment {
  frameId: string;
  reviewerId: string;
  content: {
    comment: string;
  };
}

export interface ReviewerComment {
  id: string;
  comment: string;
  status: number;
  isDeleted: boolean | null;
  createdAt: Date;
  modifiedAt: Date;
  frame: { id: string };
}

const commentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getComments: build.query<CommentsType[], void>({
      query: () => `/comments`,
      providesTags: [CommentsTag],
    }),
    getFrameComments: build.query<CommentsType[], string>({
      query: (id) => `/comments/frame/${id}`,
      providesTags: [FrameCommentsTag],
    }),
    getReviewerComments: build.query<CommentsType[], string>({
      query: (id) => `/comments/reviewer/${id}`,
      providesTags: [ReviewerCommentsTag],
    }),
    getReviewerElearningComments: build.query<ReviewerComment[], string>({
      query: (elearningId) => ({
        url: `/reviewers/reviewer/comments`,
        params: {
          'elearning-id': elearningId,
        },
      }),
      providesTags: [ReviewerElearningCommentsTag],
    }),
    createComment: build.mutation<CommentsType, CreateComment>({
      query: (body) => ({
        url: `/comments/${body.frameId}/${body.reviewerId}`,
        method: 'POST',
        body: body.content,
      }),
      invalidatesTags: [ReviewerCommentsTag, CommentsTag, FrameCommentsTag],
    }),
    deleteComment: build.mutation<any, string>({
      query: (id) => ({
        url: `/comments/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [ReviewerCommentsTag, CommentsTag, FrameCommentsTag],
    }),
    updateComment: build.mutation<any, SubmitData>({
      query: (body) => ({
        url: `/comments/${body.id}`,
        method: 'PUT',
        body: body.content,
      }),
      invalidatesTags: [ReviewerCommentsTag, CommentsTag, FrameCommentsTag],
    }),
    updateCommentStatus: build.mutation<any, SubmitData>({
      query: (body) => ({
        url: `/comments/${body.id}/status`,
        method: 'PUT',
        body: body.content,
      }),
      invalidatesTags: [ReviewerCommentsTag, CommentsTag, FrameCommentsTag],
    }),
  }),
});

export const {
  useGetCommentsQuery,
  useGetFrameCommentsQuery,
  useGetReviewerCommentsQuery,
  useCreateCommentMutation,
  useDeleteCommentMutation,
  useUpdateCommentMutation,
  useGetReviewerElearningCommentsQuery,
} = commentApi;

export default commentApi;
